import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import id from '../locales/id.json';
import ar from '../locales/ar.json';
import ms from '../locales/ms.json';

export const locales = ['id', 'en', 'ar', 'ms'];
export const defaultLocale = 'id';
export const rtlLocales = ['ar'];

// Ordered: Indonesian first
export const localeNames = {
  id: 'Bahasa Indonesia',
  en: 'English',
  ar: 'العربية',
  ms: 'Bahasa Melayu',
};

export const localeFlags = {
  id: '🇮🇩',
  en: '🇺🇸',
  ar: '🇸🇦',
  ms: '🇲🇾',
};

// Map country codes to supported languages
const countryToLocale = {
  ID: 'id', // Indonesia
  MY: 'ms', // Malaysia
  BN: 'ms', // Brunei
  SA: 'ar', // Saudi Arabia
  AE: 'ar', // UAE
  QA: 'ar', // Qatar
  KW: 'ar', // Kuwait
  BH: 'ar', // Bahrain
  OM: 'ar', // Oman
  EG: 'ar', // Egypt
  JO: 'ar', // Jordan
};

export const isRTL = (locale) => rtlLocales.includes(locale);
export const getDirection = (locale) => isRTL(locale) ? 'rtl' : 'ltr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      id: { translation: id },
      ar: { translation: ar },
      ms: { translation: ms },
    },
    fallbackLng: defaultLocale,
    supportedLngs: locales,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

// Auto-detect language from user's location (only on first visit, when no localStorage preference)
const detectLanguageFromLocation = async () => {
  try {
    // Skip if user already has a saved preference
    if (localStorage.getItem('i18nextLng')) return;

    const response = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(3000) });
    if (!response.ok) return;

    const data = await response.json();
    const countryCode = data?.country_code;
    if (countryCode && countryToLocale[countryCode]) {
      i18n.changeLanguage(countryToLocale[countryCode]);
    }
  } catch {
    // Silently fail — keep default language
  }
};

detectLanguageFromLocation();

export default i18n;
